let db = null;

export async function getDB() {
    if (!db) {
        const Dexie = await import('dexie');
        const Ctor = Dexie.default;
        db = new Ctor('form');
        db.version(1).stores({ fields: '++id' });
    }

    return db;
}
